import React from 'react';
import { css } from 'emotion';
export const Flex = ({ children, direction = 'row', justify = 'space-between', }) => (React.createElement("div", { className: css `
			display: flex;
			flex-direction: ${direction};
			justify-content: ${justify};
			/* Fixes IE 10/11 bug that collapses this container by default: */
			/* stylelint-disable-next-line property-no-vendor-prefix */
			-ms-flex-positive: 1;
		` }, children));
